module.exports = __webpack_public_path__ + "static/media/sbu.dd52abac.png";